import { useMutation } from "react-query";
import API from "../shared-utils/api";
export const useSubmitFeedback = () => {
    return useMutation(async (payload) => {
        const { data } = await API.post("/api/v1/rbzo/reviews/experience/submit", payload);
        return data;
    });
};
